var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0"}},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('br'),_c('input',{staticClass:"inputField",attrs:{"id":"input","type":_vm.type}})])])}
var staticRenderFns = []

export { render, staticRenderFns }